import { View } from 'ol';
import { get as getProjection } from 'ol/proj';
import { Tile as TileLayer } from 'ol/layer'
import { XYZ } from 'ol/source'
import GeoJSON from "ol/format/GeoJSON";
import { Vector as VectorSource } from 'ol/source'
import { settingsConfig } from 'utils/commonFunc';

//export const mapProjection = 'EPSG:900913';
export const mapProjection = 'EPSG:3857';

export const setSourceForGeoJSON = (layer, data) => {
    if (layer && data) {
        layer.setSource(getSourceForGeoJSON(data))
    }
}
export const getSourceForGeoJSON = (data) => {
    if (data) {
        return new VectorSource({
            features: new GeoJSON({ featureProjection: mapProjection }).readFeatures(data),
        })
    }
}

export const getView = (zoom, center) => {
    return new View({
        projection: getProjection(mapProjection),
        center: center,
        zoom: zoom,
        minZoom: 9,
        maxZoom: 18,
    })
}

export const setView = (map, zoom, center) => {
    const view = map?.getView()
    if (view) {
        if (center)
            view.setCenter(center)
        if (zoom)
            view.setZoom(zoom)
    }
}

export const getTileLayers = ({ tileUrl, opacity } = {}) => {
    return [
        new TileLayer({
            name: 'base',
            source: new XYZ({
                url: tileUrl ?
                    tileUrl :
                    `http://api.vworld.kr/req/wmts/1.0.0/33472E74-6D5A-38C5-9ED1-299F89762FDF/Base/{z}/{y}/{x}.png`
            }),
            //opacity: opacity ?? 1,
            minZoom: 9,
            maxZoom: 18,
            //preload: Infinity,
        }),
    ]
}

export const getDarkTileLayers = ({ tileUrl, opacity } = {}) => {
    return [
        new TileLayer({
            name: 'base',
            source: new XYZ({
                url: tileUrl ?
                    tileUrl.replace('/Base/', '/midnight/') :
                    `http://api.vworld.kr/req/wmts/1.0.0/33472E74-6D5A-38C5-9ED1-299F89762FDF/Base/{z}/{y}/{x}.png`
            }),
            //opacity: opacity ?? 1,
            minZoom: 9,
            maxZoom: 18,
            visible: true,
        }),
    ]
}

export const findLayer = (map, layerName) => {
    return map.getLayers().getArray().find(layer => layer.get('name') === layerName)
}

export const IsEmptyLayer = (map) => {
    return map.getLayers().getArray().length === 0
}

export const toggleDarkMode = (map) => {
    const baseTile = findLayer(map, 'base');
    if (map.darkModeCallBack) {
        baseTile.un('prerender', map.darkModeCallBack.prerender);
        baseTile.un('postrender', map.darkModeCallBack.postrender);
        map.darkModeCallBack = undefined;
    } else {
        map.darkModeCallBack = {
            prerender: (evt) => {
                if (evt.context) {
                    evt.context.filter = 'grayscale(60%) invert(100%) ';
                    evt.context.globalCompositeOperation = 'source-over';
                }
            },
            postrender: (evt) => {
                if (evt.context) {
                    evt.context.filter = 'none';
                }
            }
        }

        baseTile.on('prerender', map.darkModeCallBack.prerender);
        baseTile.on('postrender', map.darkModeCallBack.postrender);
    }
    map.renderSync();
}

export const setMapSingleEventHandler = (map, layer, eventName, eventHandler) => {
    const layerName = layer.get('name')
    const handlerKeyName = `${layerName}${eventName}SingleEventHandler`;

    const prevHandler = map.get(handlerKeyName);
    if (prevHandler) {
        map.un(eventName, prevHandler.listener);
        map.unset(handlerKeyName);
    }

    if (eventHandler) {
        const currenthandler = map.on(eventName, (e) => {
            const feature = e.map.forEachFeatureAtPixel(e.pixel, (feature) => feature,
                {
                    layerFilter: (layer) => layer.get('name') === layerName
                });

            if (eventName === 'pointermove') {
                if (feature) {
                    eventHandler(e, feature)
                    e.stopPropagation()
                } else {
                    eventHandler(e)
                }
            }
            if (eventName === 'click') {
                if (feature) {
                    eventHandler(e, feature)
                    e.stopPropagation()
                }
            }
        });
        map.set(handlerKeyName, currenthandler);
    }
}

export const runAnimationFeature = (layer, animationKey, totalMs, featureCallback, { progressCallBack, compltedCallBack, timeoutMs } = {}) => {
    //todo 이거 다시 짜야함
    const maxStep = totalMs === 0 ? 0 : Math.ceil(totalMs / settingsConfig().layerAnimationTickDelayMs)
    const ms = timeoutMs ?? settingsConfig().layerAnimationTickDelayMs;
    let step = 0;

    function animationFeature() {

        step += maxStep === 0 ? 0 : 1;

        const progress = maxStep === 0 ? 0 : step / maxStep

        const hashTable = {}

        if (progressCallBack) {
            progressCallBack(progress, hashTable)
        }

        layer.getSource()?.getFeatures()?.forEach((feature) => featureCallback(feature, hashTable, progress));

        if(!layer[animationKey]){
            if (compltedCallBack) {
                compltedCallBack(hashTable)
            }
            return
        }
        
        if (maxStep === 0 || progress < 1.0) {
            layer[animationKey] = setTimeout(animationFeature, ms);
        } else {
            if (compltedCallBack) {
                compltedCallBack(hashTable)
            }
        }
    }

    clearTimeout(layer[animationKey])
    layer[animationKey] = setTimeout(animationFeature, ms);
}

export const runAnimationLayer = (layer, animationKey, totalMs, layerCallback, endedCallBack) => {
    const delay = settingsConfig().layerAnimationTickDelayMs ?? 33
    const tick = delay / totalMs
    let progress = 0;
    clearTimeout(layer[animationKey])
    function animationLayer() {
        progress += tick;

        if (layerCallback) {
            layerCallback(layer, progress)
        }

        if (progress < 1.0) {
            layer[animationKey] = setTimeout(animationLayer, delay);
        } else if (endedCallBack) {
            endedCallBack(layer)
        }
    }

    animationLayer();
}

export const runAnimationLayerList = (layer, animationKey, list, isRepeat) => {

    const delay = settingsConfig().layerAnimationTickDelayMs ?? 33
    var currentIndex = 0;
    clearTimeout(layer[animationKey])
    function animationRelay() {
        if(list.length <= currentIndex)
        {
            if(isRepeat)
                currentIndex = 0
            else
                return
        }

        let { totalMs, layerCallback, gapMs } = list[currentIndex++];

        if (gapMs) {
            layer[animationKey] = setTimeout(animationRelay, gapMs);
        } else {
            const tick = delay / totalMs
            let progress = 0;
            function animationLayer() {
                progress += tick;

                if (layerCallback) {
                    layerCallback(progress >= 1 ? 1 : progress)
                }

                if (progress < 1.0) {
                    layer[animationKey] = setTimeout(animationLayer, delay);
                } else {
                    animationRelay();
                }
            }
            animationLayer();
        }
    }

    animationRelay();
}

export const stopAnimationFeature = (layer, animationKey) => {
    clearTimeout(layer[animationKey])
    layer[animationKey] = undefined;
}

export const interpolateColors = (color1, color2, progress) => {
    const rgba1 = color1.match(/\d+/g).map(Number);
    const rgba2 = color2.match(/\d+/g).map(Number);
    const interpolatedColor = rgba1.map((channel, i) => Math.round(channel + ((rgba2[i] - channel) * progress)));
    return `rgba(${interpolatedColor.join(',')})`;
}

export const reverseProgressValue = (progress, reverseValue) => {
    return (progress > reverseValue ? progress - ((progress - reverseValue) * 2) : progress) / reverseValue
}

export class CacheStyleManger {
    constructor() {
        this.cache = {}
        this.createCallback = {}
    }

    addCreateCallBack = (key, createStyleCallback) => {
        this.createCallback[key] = createStyleCallback
    }
    
    getStyles = (key, count) => {
        if(!this.cache[key])
            this.cache[key] = []

        for(var i = this.cache[key].length; i <= count; i++){
            this.cache[key].push(this.createCallback[key]())
        }
        return this.cache[key].slice(0, count)
    }
}

export const flickerLayerAnimation = (targetLayer, interval, callback) => {
    let curReverse = true
    let curValue = 1.0
    const animationKey = setInterval(() => {
        if (curReverse)
            curValue -= 0.1
        else
            curValue += 0.1

        if (curValue >= 1.0)
            curReverse = true
        else if (curValue <= 0.1)
            curReverse = false

        if (callback)
            callback(curValue)

        targetLayer.changed()
    }, interval);

    return () => clearInterval(animationKey)
}